import 'aos/dist/aos.css';
import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { guestLogin } from '../../actions/auth';
import logo from '../../images/showcase.jpg';

const GuestLogin = ({ guestLogin, isAuthenticated }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const { email, password } = formData;

    const onChange = e =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        guestLogin({ email, password });
    };

    // Navigate to HomeScreen if authenticated
    if(isAuthenticated) {
        return <Navigate to = '/homeScreen'/>
    }

  return (
    <section className='landing'>
    <div className='container' style={{ maxWidth: "500px"}}>
        <h5 className="text-light"><i className="fa-solid fa-hands-praying" /> &nbsp; Welcome back, Guest</h5>
        <Card className="transbox" style={{ width: '100%'}} data-aos='zoom-in'>
            <Card.Header><h6 className="my-1"><i className="fa fa-user"></i> Login to your account</h6></Card.Header>
            <Card.Body>
                <Card.Img variant="top" src={logo} style={{maxWidth: '500px'}}/>
                <form className="form" onSubmit={ e => onSubmit(e)}>
                    <div className="form-group">
                    <input type="email" placeholder="Email Address" name="email" required onChange={e => onChange(e)} />
                    </div>
                    <div className="form-group">
                    <input
                        type="password"
                        placeholder="Password"
                        name="password"
                        minLength="8"
                        required
                        onChange={e => onChange(e)}
                    />
                    </div>
                    <input type="submit" className="btn btn-outline-primary" value="Sign In" style={{ float: "right"}} />
                </form>
            </Card.Body>
            <Card.Footer>
                <h6 className="my-1">Don't have an account? <Link to='/guestRegister' className='text text-primary'>Register</Link></h6>
            </Card.Footer>
        </Card>
    </div>
    </section>
  )
};

GuestLogin.propTypes = {
    guestLogin: propTypes.func.isRequired,
    isAuthenticated: propTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,    
});

export default connect(mapStateToProps, {guestLogin})(GuestLogin);
